export default __webpack_public_path__ + "static/media/PostgreSQL-WindowsTaskScheduler-Result09.d209d676.png";